import { o_util } from "../chunks/common-namespaces-client-CHyZgmlk.mjs";
import { otto } from "../chunks/common-nexus-client-BxVeVD8v.mjs";
import { asExport } from "../chunks/common-core-client-BYCqsbss.mjs";
import { noop } from "../chunks/common-function-client-BVBvJr6Z.mjs";
const onex = /*           */ asExport(o_util, "onex", {});
const isOnexVariant = /*           */ asExport(
  onex,
  "isOnexVariant",
  noop
);
const mapOnexVariant = /*           */ asExport(
  onex,
  "mapOnexVariant",
  noop
);
const withOnex = /*           */ asExport(onex, "withOnex", noop);
const customAssignments = /*           */ asExport(
  onex,
  "customAssignments",
  noop
);
const onexAsync = /*           */ asExport(otto, "onex", {});
const assignments = /*           */ asExport(
  onexAsync,
  "assignments",
  {}
);
const getAssignments = /*           */ asExport(
  onexAsync,
  "getAssignments",
  noop
);
const isOnexVariantAsync = /*           */ asExport(
  onexAsync,
  "isOnexVariant",
  noop
);
const mapOnexVariantAsync = /*           */ asExport(
  onexAsync,
  "mapOnexVariant",
  noop
);
export {
  assignments,
  customAssignments,
  getAssignments,
  isOnexVariant,
  isOnexVariantAsync,
  mapOnexVariant,
  mapOnexVariantAsync,
  onex,
  onexAsync,
  withOnex
};
/*                                    */
